<template>
    <div class="collect-manage-container">
        <!-- 列表搜索过滤 -->
        <div class="search-wrap">
            <el-row :gutter="20">
                <el-col
                    class="search-btn-wrap"
                    :sm="24"
                    :md="24"
                    :lg="24"
                    :xl="24"
                    style="text-align: right;"
                >
                    <el-button size="medium" class="leader-common-button" @click="handleAdd()">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 列表 -->
        <div class="table-wrap">
            <el-table
                border
                height="90%"
                :data="tableList"
                highlight-current-row
                class="leader-style-table"
                style="width: 100%"
            >
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="数据项名称" property="mainName" align="center"></el-table-column>
                <el-table-column label="能源种类" property="className" align="center"></el-table-column>
                <el-table-column label="数据项" property="columnName" align="center"></el-table-column>
                <el-table-column label="修改" align="center" width="210">
                    <template slot-scope="scope">
                        <div class="color-blue">
                            <el-button
                                type="text"
                                class="button-modify"
                                @click="handleEditItems(scope.row, '修改')"
                            >修改</el-button>
                            <div class="split-line"></div>
                            <el-button
                                type="text"
                                class="button-modify"
                                @click="handleDelete(scope.row)"
                            >删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <!-- 新增 修改 -->
        <el-dialog
            class="leader-dialog"
            :title="dialogType === 'add' ? '新增' : '修改'"
            width="1000px"
            :visible.sync="dialogStatus"
            @close="closeDiaCb"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <div class="plan-dialog-wrap" v-loading="diaLoading">
                <el-form
                    :model="commitForm"
                    ref="commitForm"
                    style="height: 100%"
                    class="leader-style-form"
                >
                    <el-scrollbar style="height: 100%">
                        <div class="search-wrap">
                            <el-row :gutter="20">
                                <el-col class="search-btn-wrap" :span="16">
                                    <el-form-item
                                        label="数据项名称"
                                        prop="pointClassMain.mainName"
                                        label-width="120px"
                                        :rules="{
                                                required: true,
                                                message: '数据项名称不能为空',
                                                trigger: 'blur'
                                            }"
                                    
                                    >
                                        <el-input
                                            v-model="
                                                commitForm.pointClassMain
                                                    .mainName
                                            "
                                            maxlength="32"
                                            placeholder="请输入数据项名称"
                                            style="width: 100%"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col class="search-btn-wrap" :span="8"></el-col>
                                <el-col class="search-btn-wrap" :span="16">
                                    <el-form-item
                                        label="能源种类"
                                        prop="pointClassMain.pointClassId"
                                        label-width="120px"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '能源种类不能为空',
                                                trigger: 'change'
                                            }
                                        ]"
                              
                                    >
                                        <el-select
                                            v-model="
                                                commitForm.pointClassMain
                                                    .pointClassId
                                            "
                                            style="width: 100%"
                                            placeholder="请选择能源种类"
                                            @change="queryFenlei"
                                        >
                                            <el-option
                                                v-for="item in pointClassList"
                                                :key="item.pointClassId"
                                                :label="item.className"
                                                :value="item.pointClassId"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col
                                    class="search-btn-wrap"
                                    :span="8"
                                    style="text-align: right;"
                                >
                                    <el-button
                                        size="medium"
                                        class="leader-common-button"
                                        @click="handleAddItem()"
                                        :disabled="addDisabled"
                                    >新增</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                            class="leader-style-table itemsTab"
                            :data="commitForm.column"
                            height="19rem"
                            highlight-current-row
                            border
                            ref="tableRef"
                            v-loading="innerLoading"
                        >
                            <el-table-column label='数据标签' :render-header="addRedStar"  align="center" width="150" >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' +
                                            scope.$index +
                                            '.columnName'
                                        "
                          
                                        :rules="[
                                            {
                                                required: true,
                                                message: '数据标签不能为空',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            @blur="columnNameInput"
                                            maxlength="100"
                                            placeholder="请输入数据标签"
                                            v-model="scope.row.columnName"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="分类" align="center" width="150">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' +
                                            scope.$index +
                                            '.pointClassColumnKindId'
                                        "
                                    >
                                        <el-select
                                            v-model="
                                                scope.row.pointClassColumnKindId
                                            "
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="item in pointClassKindList"
                                                :key="
                                                    item.pointClassColumnKindId
                                                "
                                                :label="item.kindName"
                                                :value="
                                                    item.pointClassColumnKindId
                                                "
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="排序" align="center" :render-header="addRedStar">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' + scope.$index + '.seqNum'
                                        "
                            
                                        :rules="[
                                            {
                                                required: true,
                                                message: '排序不能为空',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            v-model="scope.row.seqNum"
                                            maxlength="3"
                                            placeholder="必填"
                                            oninput="if(value.length>3)value=value.slice(0,3)"
                                            type="number"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="中文名称" align="center" :render-header="addRedStar">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' +
                                            scope.$index +
                                            '.columnDesc'
                                        "
                           
                                        :rules="[
                                            {
                                                required: true,
                                                message: '不能为空',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input v-model="scope.row.columnDesc"    placeholder="必填" maxlength="32"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" align="center">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' +
                                            scope.$index +
                                            '.columnUnit'
                                        "
                                    >
                                        <el-input v-model="scope.row.columnUnit" maxlength="16"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="颜色" align="center">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' +
                                            scope.$index +
                                            '.columnColor'
                                        "
                                    >
                                        <el-input v-model="scope.row.columnColor" maxlength="16"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="二次变比" align="center">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'column.' +
                                            scope.$index +
                                            '.columnRate'
                                        "
                                        :show-message="false"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            v-model="scope.row.columnRate"
                                            maxlength="10"
                                            v-Int.float
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="修改" align="center" width="150">
                                <template slot-scope="scope">
                                    <div>
                                        <el-button
                                            type="danger"
                                            size="small"
                                            @click="deleteItem(scope.row)"
                                        >删除</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer"> 
                <el-button
                 
                    @click="saveCollectItems"
                    class="leader-common-button"
                >保存</el-button>
                 <el-button @click="dialogStatus = false" class="leader-common-button">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            tableList: [], //列表list
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            loading: false, //loading状态
            dialogStatus: false,
            dialogAddStatus: false,
            commitForm: {
                pointClassMain: {
                    mainName: "",
                    pointClassId: ""
                },
                column: []
            },
            types: [
                {
                    code_value: "1",
                    code_name: "11111"
                }
            ],
            curRow: null,
            pointClassList: [],
            pointClassKindList: [],
            innerLoading: false,
            addDisabled: false,
            dialogType:"add",
            
        };
    },
    created() {
        this.getPointManageList();
        this.getPointClassList(); //查询下拉
    },
    methods: {
        // 给表头加必填符号*
        addRedStar(h, { column }) {
            return [
                h("span", { style: "color: #F56C6C" }, "*"),
                h("span", " " + column.label),
            ];
        },
        getPointManageList() {
            this.loading = true;
            api.getPointClassMainList({
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableList = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
                this.loading = false;
            });
        },
        getPointClassList() {
            api.getPointClassList({
                pageNum: 1,
                pageSize: 9999
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.pointClassList = res.bus_json.items;
                }
            });
        },
        queryFenlei() {
            this.innerLoading = true;
            api.getPointClassColumnKindSelect({
                pointClassId: this.commitForm.pointClassMain.pointClassId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.pointClassKindList = res.bus_json;
                    this.commitForm.column.map(item => {
                        item.pointClassColumnKindId = "";
                    });
                }
                this.innerLoading = false;
            });
        },
        handleAdd() {
            this.dialogType="add";
            this.dialogStatus = true;
            this.commitForm = {
                pointClassMain: {
                    mainName: "",
                    pointClassId: ""
                },
                column: []
            };
        },
        // 验证数据项输入的时候，不能重复
        columnNameInput(event) {
            let a = {};
            this.commitForm.column.forEach(item => {
                if (item.columnName == event.target.value) {
                    if (a[event.target.value]) {
                        this.$message.error("数据项名称不能重复");
                        event.target.value = "";
                        return;
                    } else {
                        a[event.target.value] = 1;
                    }
                }
            });

        },
        handleEditItems(row) {
            this.dialogStatus = true;
            this.addDisabled = true;
            this.dialogType="modify";
            console.log(this.dialogType);
            api.getPointClassMainDetail({
                pointClassMainId: row.pointClassMainId
            }).then(res => {
                if (res && res.error_code === "0") {
                    const pointClassMain = res.bus_json.pointClassMain;
                    const column = res.bus_json.column;
                    if (pointClassMain && pointClassMain.pointClassId) {
                        api.getPointClassColumnKindSelect({
                            pointClassId: pointClassMain.pointClassId
                        }).then(res => {
                            if (res && res.error_code === "0") {
                                this.pointClassKindList = res.bus_json;
                                this.$nextTick(() => {
                                    this.commitForm = {
                                        pointClassMain: {
                                            mainName: pointClassMain.mainName,
                                            pointClassId:
                                                pointClassMain.pointClassId,
                                            pointClassMainId:
                                                pointClassMain.pointClassMainId
                                        },
                                        column:
                                            column && column.length
                                                ? column
                                                : []
                                    };
                                    this.addDisabled = false;
                                });
                            }
                        });
                    }
                }
            });
        },
        handleAddItem() {
            let emptyItem = {
                columnColor: "",
                columnDesc: "",
                columnName: "",
                columnRate: "1",
                columnUnit: "",
                pointClassColumnKindId: "",
                seqNum: "", //排序
                pointClassMainId: ""
            };
            this.commitForm.column = [...this.commitForm.column, emptyItem];
            console.log("handleAddItem: ", this.commitForm.column);
        },
        saveCollectItems() {
            this.$refs["commitForm"].validate(valid => {
                if (valid) {
                    if (
                        !(
                            this.commitForm.column &&
                            this.commitForm.column.length
                        )
                    ) {
                        this.$message({
                            type: "warning",
                            message: "请添加数据项"
                        });
                        return;
                    }
                    api.savePointClassMainDetail(this.commitForm).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getPointManageList();
                        }
                        this.dialogStatus = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleDelete(row) {
            this.$confirm("确认删除这条数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deletePointClass({
                    pointClassMainId: row.pointClassMainId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.$message({
                            type: "success",
                            message: res.error_msg
                        });
                        if (
                            this.totalNum -
                            (this.pageNum - 1) * this.pageSize ==
                            1
                        ) {
                            this.pageNum =
                                this.pageNum == 1
                                    ? this.pageNum
                                    : this.pageNum - 1;
                        }
                        this.getPointManageList();
                    }
                    this.dialogStatus = false;
                });
            });
        },
        deleteItem(sth) {
            // this.$confirm("确认删除这条数据吗？", "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning"
            // }).then(_ => {
            this.commitForm.column.forEach(function (item, index, arr) {
                if (item == sth) {
                    arr.splice(index, 1);
                }
            });
            // });
        },
        closeDiaCb() {
            this.$refs.commitForm.resetFields();
            //  this.dialogAddStatus = false;
            this.commitForm = {
                pointClassMain: {
                    mainName: "",
                    pointClassId: ""
                },
                column: []
            };
        },
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getPointManageList();
        },
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getPointManageList();
        }
    }
};
</script>
<style lang="scss">
.collect-manage-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: px2Rem(20px);
    .leader-dialog .el-table--border::after,
    .el-table--group::after {
        width: 0;
    }
    .itemsTab .el-form-item .el-form-item__content {
        padding: 0 !important;
    }
    // .leader-dialog .el-form-item {
    //     margin-bottom: 0 !important;
    // }
    .el-pagination {
        margin-top: 20px;
    }

    .button-green {
        color: #40be6c;
    }

    .button-red {
        color: #ff8971;
    }

    .button-blue {
        color: #0090e7;
    }

    .el-select {
        width: 100%;
    }

    .split-line {
        width: 2px;
        height: 12px;
        background: #adadad;
        display: inline-block;
        margin: 0 8px;
        vertical-align: middle;
    }

    // .search-btn-wrap {
    //     text-align: right;
    // }

    .search-wrap {
        .button-group {
            display: inline-block;
            margin-left: 20px;
            button {
                background: rgb(41, 184, 94);
                color: white;
                outline: none;
                border-color: rgb(41, 184, 94);
            }
            .el-button.is-disabled,
            .el-button.is-disabled:focus,
            .el-button.is-disabled:hover {
                border-color: #ebeef5;
            }
        }
    }
    .itemsTab .el-form-item {
        margin-bottom: 0 !important;
        margin-right: 0 !important;
    }
}
</style>
